module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai147-ea2078acf82eb321b5fe48a0eb560e3c.jpg";